module.exports = __webpack_public_path__ + "media/components/page-header/static/weather-badge--light-57ec981f714d7f11500f42910600193b.svg";